module.exports = __webpack_public_path__ + "static/img/bg3.ccebfb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg3.jpg
// module id = 9Gbh
// module chunks = 0